/**
 * 安聆 SafeListen - Supabase 客户端（Realtime 推送，替代轮询）
 * 需配置环境变量：REACT_APP_SUPABASE_URL、REACT_APP_SUPABASE_ANON_KEY
 */
import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = url && anonKey ? createClient(url, anonKey) : null;

export const TABLE_ACTIVE_CODES = 'active_codes';
